import Vue from 'vue'
import Vuex from 'vuex'
import { loginAPI } from '@/api/login'
import Storage from '@/utils/storage'
import event from './modules/event'
import i18n from '@/i18n/index.js'
import {
  dictDetailMapApi
} from '@/api/home'
import { dataScopeUserListApi } from '@/api/user'
// import { arsProjectAppQueryListApi } from '@/api/storeMaintain'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 开启严格模式 —— 一切数据 的修改 只能 通过 mutation 进行
  strict: true,
  state: {
    usToken: Storage.get('usToken'),
    userInfo: {
      name: '',
      photo: Storage.get('photo')
    },
    myUserInfo: Storage.get('myUserInfo') ? JSON.parse(Storage.get('myUserInfo')) : {},
    storeNum: localStorage.getItem('storeTotal') || '',
    globalData: Storage.get('globalData') ? JSON.parse(Storage.get('globalData')) : {},
    selectedPolicy: null,
    storeMaintainFilter: {}
  },
  mutations: {
    setStoreMaintainFilter (state, policy) {
      state.storeMaintainFilter = policy
    },
    setSelectedPolicy (state, policy) {
      state.selectedPolicy = policy
    },
    setToken (state, tokenStr) {
      state.usToken = tokenStr
      Storage.set('usToken', tokenStr)
    },
    setUSERINFO (state, userobj) {
      state.myUserInfo = userobj
      Storage.set('myUserInfo', JSON.stringify(userobj))
    },
    setGlobalData (state, params = []) {
      params.forEach(subItem => {
        state.globalData[subItem.key] = subItem.val
      })
      Storage.set('globalData', JSON.stringify(state.globalData))
    },
    setUserInfo (state, userObj) {
      state.userInfo = userObj
    },
    setUserName (state, val) {
      state.userInfo.name = val
    },
    setUserPhoto (state, val) {
      state.userInfo.photo = val
      Storage.set('photo', val)
    }
  },
  actions: {
    async asyncLoginAction (store, formLogin) {
      // 1. 发送登录请求
      const resp = await loginAPI(formLogin)
      const { token, user } = resp.data
      // 2. 提交到mutation - 同步token 和 refreshToken
      store.commit('setToken', token)
      store.commit('setUSERINFO', user)
      const backendLang = user.user && user.user.language
      // 后端没返回语言，或语言不在本地语言包中，一律用英文
      const currentLang = ['en', 'zh', 'fr', 'it', 'es', 'id'].includes(backendLang) ? backendLang : 'en'
      i18n.locale = currentLang
      localStorage.setItem('currentLang', currentLang)
      let dictList = []
      const result1 = await dictDetailMapApi('closeBrand,openBrand,customerType,banType,customerJob,shelfType,countryList,payType,sdBusinessType')
      const { closeBrand = [], openBrand = [], customerType = [], banType = [], customerJob = [], shelfType = [], countryList = [], payType = [], sdBusinessType = [] } = result1.data
      banType.forEach(item => {
        item.value = JSON.parse(item.value)
      })
      dictList = [
        { key: 'openBrandList', val: openBrand },
        { key: 'closeBrandList', val: closeBrand },
        { key: 'customerTypeList', val: customerType },
        { key: 'banTypeList', val: banType },
        { key: 'customerJob', val: customerJob },
        { key: 'shelfType', val: shelfType },
        { key: 'countryList', val: countryList },
        { key: 'payType', val: payType },
        { key: 'sdBusinessType', val: sdBusinessType }
      ]
      // 用户
      const result2 = await dataScopeUserListApi()
      dictList.push({ key: 'userOptions', val: result2.data })
      // const result3 = await arsProjectAppQueryListApi()
      // dictList.push({ key: 'brandProductList', val: result3.data })
      // 产品
      // const result4 = await arsProductListApi()
      // dictList.push({ key: 'productList', val: result4.data })
      store.commit('setGlobalData', dictList)
    }
  },
  modules: {
    event
  }
})

export default store
